import {handleAPI, API_VERSION_ONE_ADMIN} from '../../../utils/apiUtils';
const parent = 'SETTING'

export function templateLoad(filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/templates`;
  const method = 'GET'

  return {
    type: `${parent}ORDER_TEMPLATE_LOAD`,
    payload: handleAPI(url,filters,method)
  };
}

export function templateUpdate(id, data, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/templates/${id}`;
  const method = "PUT"
  return {
    type: `${parent}ORDER_TEMPLATE_UPDATE`,
    payload: handleAPI(url,filters,method, {template: {...data}})
  }
}
